import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { OrderTrakingModel, OrderTrakingPutModel } from '../model/order-traking.model';
import { headersBase } from '../../../../helper/headerBase';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable()
export class OrderTrackingServiceRest {

  constructor(
    private http: HttpClient
  ) { }

  public getTrakingService(page: number, param: string, filterOrderStatesSelected: string, registerLimite: boolean): Observable<OrderTrakingModel> {
    return this.http.get<OrderTrakingModel>(`Order/Getorders/${page}/${param}?status=${filterOrderStatesSelected}&registerLimite=${registerLimite}`, headersBase());
  }

  public getOrdersByAccountIdService(accoutId: string): Observable<OrderTrakingModel> {
    return this.http.get<OrderTrakingModel>(`Order/GetOrdersByAccountId/${accoutId}`, headersBase());
  }

  public createshowCase(showCase: OrderTrakingModel) {
    return this.http.post<OrderTrakingModel>(`/showCases`, showCase, headersBase());
  }

  public updateTrakingService(id: string): Observable<OrderTrakingPutModel> {
    return this.http.put<OrderTrakingPutModel>(`/Order/PutReprocessOrder/${id}`, null, headersBase());
  }

  public deleteshowCase(id: string): Observable<any> {
    return this.http.delete(`/showCases/${id}`, headersBase());
  }

  public getHomeManager(param: string): Observable<OrderTrakingModel[]> {
    return this.http.get<OrderTrakingModel[]>(`/home-content/${param}`, headersBase());
  }

}

